/*
 * Menus flutuantes do cabeçalho: o de conta e os submenus de navegação.
 *
 * O <details> já abre e fecha sozinho — este arquivo só acrescenta o que ele
 * não faz: fechar ao clicar fora e ao apertar Esc. Sem JavaScript os menus
 * continuam funcionando; fecham no segundo clique no gatilho.
 *
 * A sanfona do menu móvel NÃO entra aqui de propósito. Lá o painel ocupa a
 * tela inteira e fechar ao clicar fora fecharia o grupo a cada toque dentro
 * do próprio menu.
 *
 * Nenhuma string de interface aqui: o que é texto vive em locales/.
 */
(function () {
  'use strict';

  var menus = document.querySelectorAll('[data-conta-menu], [data-menu-suspenso]');
  if (menus.length === 0) return;

  function fechar(exceto) {
    menus.forEach(function (menu) {
      if (menu !== exceto) menu.open = false;
    });
  }

  document.addEventListener('click', function (evento) {
    var dentro = evento.target.closest('[data-conta-menu], [data-menu-suspenso]');
    fechar(dentro);
  });

  document.addEventListener('keydown', function (evento) {
    if (evento.key !== 'Escape') return;

    var aberto = null;
    menus.forEach(function (menu) {
      if (menu.open) aberto = menu;
    });
    if (aberto === null) return;

    aberto.open = false;

    /* O foco volta pro gatilho, senão fica solto no documento. */
    var gatilho = aberto.querySelector('summary');
    if (gatilho) gatilho.focus();
  });
})();
